import React, { useState, useEffect } from 'react';

import {} from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import GroupService from 'Services/GroupService';

const Apps = (props) => {
    const history = useHistory();
    const {
        match: { params },
    } = props;
    const [group, setGroup] = useState(null);

    useEffect(() => {
        if (params.groupId) {
            GroupService.getGroupById(params.groupId)
                .then((result) => {
                    if (result.status === 200) {
                        setGroup(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params]);

    const onDelete = () => {
        GroupService.deleteGroup(group)
            .then((result) => {
                if (result.status === 200) {
                    history.push('/admin/group/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">Delete Group</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{params.groupId}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6 d-flex flex-column align-items-center">
                    <img src="/images/alert.svg" alt="" style={{ width: '100pt' }} className="d-block" />
                    <h4 className="py-3">Irreversible Action</h4>
                    <button className="btn btn-danger" onClick={onDelete}>
                        Delete {group && group.name}
                    </button>
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default Apps;
